<div class="ringover-widget-container" *ngIf="telephone">
  <a [href]="'tel:' + telephone" class="ringover-btn btn-call" title="Appeler avec Ringover">
    <i class="pi pi-phone"></i>
  </a>
  
  <button type="button" class="ringover-btn btn-sms" (click)="openSmsModal()" title="Envoyer un SMS via Ringover">
    <i class="pi pi-comment"></i>
  </button>
</div>

<!-- Simple SMS Modal -->
<div class="sms-modal-backdrop" *ngIf="isSmsModalOpen">
  <div class="sms-modal">
    <div class="sms-modal-header">
      <h3>Envoyer un SMS à {{ telephone }}</h3>
      <button class="close-btn" (click)="closeSmsModal()">&times;</button>
    </div>
    <div class="sms-modal-body">
      <textarea [(ngModel)]="smsMessage" placeholder="Écrivez votre message ici..." rows="4"></textarea>
    </div>
    <div class="sms-modal-footer">
      <button class="btn btn-secondary" (click)="closeSmsModal()">Annuler</button>
      <button class="btn btn-primary" (click)="sendSms()" [disabled]="!smsMessage.trim() || isSendingSms">
        <i class="pi pi-send"></i> Envoyer
        <span *ngIf="isSendingSms" class="spinner"></span>
      </button>
    </div>
  </div>
</div>
